import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  IMessageMetadata,
  INotificationMessage,
  MessageEventType,
} from '@boma/shared/entities';
import {
  NotificationMessagesFacade,
  selectAddingMessageEvents,
} from '@boma/supplier-portal/notifications';
import { NotificationType } from '@boma/supplier-portal/shared/entities';
import { LoggingService } from '@boma/supplier-portal/shared/services';
import { Store } from '@ngrx/store';
import { take, takeWhile, tap } from 'rxjs/operators';

@Component({
  selector: 'notification-list-item',
  templateUrl: './notification-list-item.component.html',
  styleUrls: ['./notification-list-item.component.css'],
})
export class NotificationListItemComponent implements OnInit, OnChanges {
  @Input() message: INotificationMessage;
  messageRead: boolean;
  markingAsRead$ = this.notificationMessagesFacade.addingMessageEvents$;
  notificationType: NotificationType;

  constructor(
    private notificationMessagesFacade: NotificationMessagesFacade,
    private router: Router,
    private store: Store,
    private loggingService: LoggingService
  ) {}

  ngOnInit(): void {
    this.notificationType =
      NotificationType[
        this.message.metadata.filter((e) => e.key === 'type')[0]?.value
      ];

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  markAsRead(messageIds: string[]): void {
    if (messageIds == null) {
      this.notificationMessagesFacade.messages$.pipe(
        take(1),
        tap((messages) => {
          const ids = messages.map((m) => m.id);
          this.notificationMessagesFacade.addEventsToMessage(
            ids.map((id) => ({
              messageId: id,
              eventType: MessageEventType.Read,
            }))
          );
          this.store
            .select(selectAddingMessageEvents)
            .pipe(takeWhile((val) => val === true))
            .subscribe((_) => {
              const current =
                this.notificationMessagesFacade.unreadMessageCount$.value || 1;
              this.notificationMessagesFacade.unreadMessageCount$.next(
                current - 1
              );
            });
        })
      );
    } else {
      this.notificationMessagesFacade.addEventsToMessage(
        messageIds.map((id) => ({
          messageId: id,
          eventType: MessageEventType.Read,
        }))
      );
    }
  }

  handleNotificationClick(message: INotificationMessage, notificationType) {
    const messageRead = message.messageEvents.some(
      (event) => event.messageEventType === MessageEventType.Read
    );
    if (!messageRead) {
      this.markAsRead([message.id]);
    }
    console.log('Handle click', message);
    console.log(notificationType);
    switch (notificationType) {
      case NotificationType.OrderCreated: {
        this._navigateTo(message.metadata, 'orderId', '/orders/order/detail');
        break;
      }
      case NotificationType.OrderMessageCreated: {
        this._navigateTo(message.metadata, 'orderId', '/orders/order/detail');
        break;
      }
      case NotificationType.OrderStatusUpdate: {
        this._navigateTo(message.metadata, 'orderId', '/orders/order/detail');
        break;
      }
      case NotificationType.JournalCashUpVariance:
        this.router.navigate(['/', 'bank']);
        break;
      case NotificationType.JournalEventCreated:
        this.router.navigate(['/', 'bank']);
        break;
      case NotificationType.LocationCreated:
        this._navigateTo(message.metadata, 'locationId', '/locations');
        break;
      case NotificationType.ProductPriceUpdated:
        this.router.navigate(['/', 'pricing']);
        break;
      case NotificationType.EntityCustomerCreated:
        this._navigateTo(message.metadata, 'customerEntityId', '/customers');
        break;
      case NotificationType.GlobalProductApproved:
        this._navigateTo(message.metadata, 'productId', '/catalogue');
        break;
      case NotificationType.StockEventCreated:
        this._navigateTo(message.metadata, 'stockEventId', '/inventory');
        break;
      case NotificationType.MinimumStockLevel:
        console.log(message.metadata);
        this._navigateTo(message.metadata, 'locationId', '/locations');
        // we probably need a to show the product too..
        break;
      default:
        this.loggingService.logDebug(
          'Unknown notification type',
          notificationType
        );
        break;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.messageRead = (
      changes.message.currentValue as INotificationMessage
    )?.messageEvents.some(
      (x) =>
        (x.messageEventType as any) === MessageEventType[MessageEventType.Read]
    );
  }

  private _navigateTo(messageMetadata: IMessageMetadata[], key, path) {
    const id = messageMetadata.find((e) => e.key === key);
    this.router.navigate([path, id.value]);
  }
}
